/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_StatusInputs */

const en_admin_payments_status = /** @type {(inputs: Admin_Payments_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const zh_admin_payments_status = /** @type {(inputs: Admin_Payments_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Admin_Payments_StatusInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_status = /** @type {((inputs?: Admin_Payments_StatusInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_StatusInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_status(inputs)
	return zh_admin_payments_status(inputs)
});
export { admin_payments_status as "admin.payments.status" }